import React, {Component} from 'react';
import './Game.scss';
import {siteHelper, swap} from "../../helpers/exportConsts";
import Gameboard from "../../components/gameboard";
import Solution from "../../components/solution/Solution";
import routes from "../../helpers/exportRoutes";

class Game extends Component {

  /*
    REFERENCE

    0   |    1   |    2

    ----c1------c2-----
    3   |   4   |    5

    ----c3------c4-----

    6  |   7   |    8

    1 : Horizontal
    0 : Vertical

   */
  constructor(props) {
    super(props);
    this.solution = [];
    this.state = {
      arr: [],
      solution: [],
      gameState: 'gameOn',
      target: 0,
      movesMade: 0
    }
  }

  init = () => {
    const arr = new Array(9).fill(1).map( (_, i) => i+1 );
    const loop = Math.floor(Math.random()*4) + 3;
    let target  = 0;
    let swapDirection, swapSite;
    const solution = [{
      swapDirection: 0,
      swapSite: 0
    }];
    for(let x = 0; x <= loop; x++)
      for(let y = 0; y < 2; y++)
        for(let z = 0; z < 2; z++) {
          swapDirection = Math.round(Math.random());
          swapSite = Math.floor(Math.random() * 4);
          swap(arr, swapDirection, siteHelper[swapSite]);
          target++;
          solution.push({swapDirection: swapDirection, swapSite: swapSite});
        }
    this.setState({...this.state, arr, target, solution});
  };


  componentDidMount() {
    this.init();
  }

  changeGameState(gameState, movesMade) {
    this.setState({...this.state, gameState, movesMade});
  }

  showGameStateObject() {
    // eslint-disable-next-line default-case
    switch (this.state.gameState) {
      case "gameOn"  :
                   return (<Gameboard arr={this.state.arr}
                   changeGameState ={this.changeGameState.bind(this)}
                   checkArr = {JSON.stringify(this.state.arr)}/>) ;
      case "gameOff" :
                    return (<div className={'row'}>
                      <div className="col-md-12 win">
                        You win!
                        <h3>Minimum moves : {this.state.target} </h3>
                        <h3>Total moves made : {this.state.movesMade}</h3>
                      </div>
                      <div className={'col-md-12'}>
                        <a href={routes.game}>
                          <button className={'action'} type={'submit'}>Play Again!</button>
                        </a>
                      </div>
                    </div>) ;
      case "solution" :
                    return (<Solution
                      solution = {this.state.solution}
                      changeGameState ={this.changeGameState.bind(this)}
                      arr = {this.state.arr}
                      target = {this.state.target}
                    />) ;

    }
  }

  render() {
    return(
      <div className={'row Game'}>
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                {this.showGameStateObject()}
              </div>
              <div className="col-md-4 info">
                Hey there, on the left hand side you see a matrix and some swapping buttons. Your goal is to match the
                number in a cell to its respective superscript. You can use row swap and column to achieve your goal.
                <br/>
                <strong>Note : </strong>Swapping only affects two rows and two columnns corresponding to the swapping button.
                <br/><br/>
                <button className={'action'} onClick={() => {this.changeGameState("solution", 0)}}>
                  Show Solution</button>
                <br/><br/>
                <div className="row" style={{lineHeight: '1.1'}}>
                  <div className="block hr mr-2"/>
                  Row Swap
                </div>
                <br/>
                <div className="row" style={{lineHeight: '1.1'}}>
                  <div className="block vr mr-2"/>
                  Column Swap
                </div>
              </div>
            </div>
          </div>
      </div>
    )
  }
}

export default Game;